module.exports = __webpack_public_path__ + "img/banner1-cimpe.d088ed5e.jpg";